module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud3_m.e35e0ca6045f7b80e9335f1c088ac9c2.png";